module.exports = __webpack_public_path__ + "img/center-on-02.350ec67f.jpg";